<template>
    <div class="blkt">
        <div style="display:flex">
            <div class="txt1">{{item.tit}}</div>
            <div class="txt2">{{item.subtit}}</div>
        </div>
    </div>
</template>
<script>
    export default{
         props:['item']
    }
</script>
<style scoped>
    .blkt{
        position:relative;margin:0 auto;padding:10px 13px;background:#fff;border-bottom:1px solid #f2f2f2
    }
    .txt1{
        overflow:hidden;
        　　text-overflow:ellipsis;
        　　white-space:wrap;flex:0 0 100px;text-align:left;font-size: 12px;font-weight: 400;color: #666;
    }
    .txt2{
        word-break:break-all;flex:1;text-align:right;font-size: 13px;font-weight: 400;color: #333333;
    }
</style>

